<div class="my-2 mb-4">
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 0,
          label: 'P00039.card.state.cover.title.toopen' | translate,
          icon: 'fa-kit fa-picto-couvfermeedeux',
          color: 'color-green',
        },
        {
          ref: 1,
          label: 'P00039.card.state.cover.title.toclose' | translate,
          icon: 'fa-kit fa-picto-couvouvertedeux',
          color: 'color-red',
        },
      ]"
      [value]="this.actionStack!.getValue('couvertureManuelleCEtatVolet')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.CouvertureManuelle_Controle,
          'couvertureManuelleCEtatVolet',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>
